export const LIST_ALLOCATION_GAPS = `
  query ListAllocationGaps($status: String) {
    listAllocationGaps(status: $status) {
      gapId
      scenario
      status
      subState
      accountId
      accountName
      region
      productCode
      iamPrincipal
      resourceArn
      estimatedMonthlyCost
      detectedAt
      detectedBy
      actionedAt
      actionedBy
      resolvedAt
      resolvedBy
      recalledAt
      recalledBy
      workloadId
      auditTrail
    }
  }
`
